import { create } from "zustand";
import { useDataStore } from "./dataStore";

type DispatchStore = {
    //state..
    error: boolean;
    errorMsg: string;
    success: boolean;
    warning: boolean;
    warningMsg: string;
    info: boolean;
    infoMsg: string;
    async: boolean;
    asyncMsg: string;


    //mutations..
    resetStates: () => void;
    dispatchAlert: (type: "error" | "info" | "warning" | "success" | "async", message?: string, duration?: number | null) => void;
}

export const useAlertDispatch = create<DispatchStore>((set, get) => ({
    //state..
    error: false,
    errorMsg: "",
    success: false,
    warning: false,
    warningMsg: "",
    info: false,
    infoMsg: "",
    async: false,
    asyncMsg: "",

    //mutations..
    resetStates: () => {
        set({
            error: false,
            errorMsg: "",
            success: false,
            warning: false,
            warningMsg: "",
            info: false,
            infoMsg: "",
            async: false,
            asyncMsg: "",
        })
    },
    dispatchAlert: (type, message, duration) => {
        if (type !== "success") {
            set({
                [type]: true,
                [`${type}Msg`]: message,
            })

            if (duration !== null && duration !== 0) {
                return setTimeout(() => { get().resetStates(); }, 5000)
            }
            else return setTimeout(() => { get().resetStates(); }, duration)
        }
        else {
            get().resetStates()
        }
    }
}));